export interface VideoObject {
  date: string;
  eduID: number;
  videoTime: number;
}
export type VideoObjectList = VideoObject[];

const TAG = 'SmartSafeTbm@TBMSafeStudy';
let catchedVideoObjectList: VideoObjectList = [];

export const setVideoObject = (videoObject: VideoObject) => {
  const videoObjectList = getVideoObjectList();
  const index = videoObjectList.findIndex(v => v.date === videoObject.date && v.eduID === videoObject.eduID);
  if(index !== -1) {
    videoObjectList[index] = {
      date: videoObject.date,
      eduID: videoObject.eduID,
      videoTime: Math.max(videoObjectList[index].videoTime, videoObject.videoTime)
    }
  } else {
    videoObjectList.push(videoObject);
  }
  // console.log(videoObjectList);
  localStorage.setItem(TAG, JSON.stringify(videoObjectList));
}

export const getVideoObjectList = () => {
  if(!catchedVideoObjectList.length) {
    catchedVideoObjectList = JSON.parse(localStorage.getItem(TAG) || '[]');
  }
  return catchedVideoObjectList;
}

export const getVideoObject = ({ date, eduID }: { date: string, eduID: number }): VideoObject|undefined => {
  const videoObjectList = getVideoObjectList();
  const videoObject  = videoObjectList.find(v => v.date === date && v.eduID === eduID);
  return videoObject;
}

export const removeExpiredVideoObject = () => {
  const videoObjectList = getVideoObjectList();
  if(!Array.isArray(videoObjectList)) {
    localStorage.removeItem(TAG);
    return;
  }

  const todayVideoObjectList = videoObjectList.filter(v => v.date === today()) || [];
  // console.log(todayVideoObjectList);
  localStorage.setItem(TAG, JSON.stringify(todayVideoObjectList));
}

const today = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작하므로 +1 필요
  const date = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${date}`;
}